export default "__VITE_ASSET__wHQQ2X9u__"